module.exports = __webpack_public_path__ + "static/things-logo-faf4015712579c55e89e7e93978cfb03.jpg";